import { render, staticRenderFns } from "./TruckSnippet.vue?vue&type=template&id=23d99f04"
import script from "./TruckSnippet.vue?vue&type=script&lang=js"
export * from "./TruckSnippet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports